<template>
<div class="wrap">
    <wedHd></wedHd>

<!-- <div class="wepTex">
    <div class="title">彩讯5G新消息平台X行业应用</div>
    <div class="text">彩讯5G新消息平台是连接行业客户与底层消息中心，通过对内容、消息、任务的综合管理实现5G消息的场景化下发，助力行业客户实现消息场景升级。</div>
</div> -->

<div class="contentBox contentList">
    <div class="titleBox">行业应用</div>

    <ul class="coreWrap core_app">
        <li>
            <img src="@/assets/images/wap/industry01.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/industry02.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/industry03.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/industry04.png" alt="">
        </li>
    </ul>
</div>

<div class="contentBox contentList contentValue">
    <div class="titleBox">行业价值</div>

    <ul class="coreWrap">
        <li>
            <p>全新连接用户的渠道方式，全新的5G消息生态可以带来更丰富、更便捷的行业应用场景，从而实现更多客户价值。</p>
            <img src="@/assets/images/wap/value01.png" alt="">
        </li>
        <li>
            <p>不同于APP、微信公众号，5G消息用户触达范围更广，用户无需下载安装、无需关注即可使用，三网消息100%覆盖。</p>
            <img src="@/assets/images/wap/value02.png" alt="">
        </li>
        <li>
            <p>运营商官方审核认证的5G消息入口，更具权威性。企业名称+logo+企业统一消息端口号展示+认证告知，5G消息企业品牌展示更友好。</p>
            <img src="@/assets/images/wap/value03.png" alt="">
        </li>
        <li>
            <p>5G新消息基于消息机制的交互方式符合OTT、短信用户使用习惯，低门槛的使用方式意味者行业客户无需额外投入客户培育。</p>
            <img src="@/assets/images/wap/value04.png" alt="">
        </li>
        <li>
            <p>运营商通过SIM卡放号，拥有所有用户的实名信息，以及非常成熟的认证流程，可用于各种高安全性的业务。</p>
            <img src="@/assets/images/wap/value05.png" alt="">
        </li>
    </ul>
</div>



<div class="contentBox contentList">
    <div class="titleBox">行业案例</div>
    <div class="titleNav">
        <span>消息通知</span> | <span>信息查询</span> | <span>自助业务办理</span> | <span>客服服务</span>
    </div>
    <div class="navTitle">金融</div>
    <div class="contentBoxVideo">
        <div class="title">银行卡激活</div>
        <div class="conVideo">
            <img  src="@/assets/images/wap/bankcard.gif" alt="">
        </div>
    </div>
    <div class="navTitle">汽车</div>
    <div class="contentBoxVideo">
        <div class="title">我要买车</div>
        <div class="conVideo">
            <img  src="@/assets/images/wap/buycars.gif" alt="">
        </div>
    </div>
    <div class="navTitle">交通</div>
    <div class="contentBoxVideo" style="padding-bottom:10px">
        <div class="title">机票预订</div>
        <div class="conVideo">
            <img  src="@/assets/images/wap/airticket.gif" alt="">
        </div>
    </div>
</div>
  <wedFt></wedFt>
 <!-- <div class="footBtn">
     <img src="@/assets/images/wap/footLogo.png" alt="">
     <p>版权所有 © 彩讯科技股份有限公司.All right reserved</p>
     <p>粤ICP备15050890号-2</p>
 </div> -->
</div>
</template>

<script>
import wedHd from '@/components/wepHearder.vue'
import wedFt from '@/components/wefot.vue'
export default {
    components:{
        wedHd,
        wedFt,
    },
    name: 'wapHome',
    data(){
        return{
            'photo-o':'@/assets/images/wap/banner1.png',
            show: false
            // actions: [{ name: '选项一' }, { name: '选项二' }, { name: '选项三' }],
        }
    },
    methods:{
        moses(val){
            console.log(val)
        },
        onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      Toast(item.name);
    }
    }
}
</script>
<style scoped>

img{
    width: 100%;
}
p{
    margin: 0;
    padding: 0;
}
.navTitle{
    font-size: 0.4rem;
    padding: 20px 0 20px 20px;
    width: 100%;
    position: relative;
}
.navTitle::before{
    content: "";
    display: block;
    position: absolute;
    width: 3px;
    height: 16px;
    border-radius: 20px;
    background-color: #178EFB;
    left: 10px;
    top: 23px;
}
.conVideo{
    height: 500px;
    background-color: #000;
    margin: 20px;
}
.conVideo img{
    width: 100%;
    height:100%;
    object-fit: contain;
}
/* .contentBoxVideo{
    padding-bottom: 20px;
} */
.contentBoxVideo .title{
    font-size: 0.48rem;
    width: 100%;
    text-align: center;
}
.titleNav{
    font-size: 0.37rem;
    padding: 10px;
    color: #8994A0;
}
.titleNav span{
    padding: 0 5px;
}
.contentBox.contentValue{

}
.contentBox.contentValue .coreWrap{
    display: inline-block;
}
.contentBox.contentValue .coreWrap li{
    display: flex;
    justify-content: space-between;
    /* height: 124px; */
    align-items: center;
    width: 100%;
    border-top: none;
}
.contentBox.contentValue .coreWrap li p{
    font-size: 0.37rem;
    flex: 1;
    line-height: 1.5;
    text-align: left;
    padding:30px 15px;
    box-sizing: border-box;
    color: #4D5865;
}
.contentBox.contentValue .coreWrap li img{
    width: 3.34rem;
    height: 3.31rem;
}
.itemBox{
    width: 100%;
    height: 240px;
}

.contentList .core_app li img{
    width: 100%;
    /* width: 187px; */
    /* height: 225px; */
}
.conBg{
    width: 336px;
    height: 159px;
    margin: 0 auto;
}
.productionBoxThree .coreWrap{
    display: flex;
    justify-content: space-between;
}
.productionBoxThree .coreWrap  li{
    display: flex;
    flex-direction: column;
    text-align: center;
}
.productionBoxThree .coreWrap  li P:first-child{
    font-size: 15px;
    color: #1C2A39;
    padding-bottom: 10px;
}
.productionBoxThree .coreWrap  li P:last-child{
    font-size: 12px;
    color: #4D5865;
}
.productionBoxThree .coreWrap  li:first-child{
    border-right: 1px solid #D8DADD;
}
.productionBoxTow{

}
.productionBoxTow .ulBOx{
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
}
.productionBoxTow .ulBOx li{
    width: 143px;
    height: 162px;
    
}
.productionBoxTow .ulBOx li img{
    width: 100%;
}
.productionBox{
    width: 100%;
    height: auto;
    margin-top: 10px;
    color: #1C2A39;
    font-size: 20px;
    background: url(../../assets/images/wap/title.png) no-repeat left top #fff;
    background-size: 29px;
    padding-left: 15px;
    border-bottom: 1px solid #EDEEF0;
    padding: 30px 20px;
}
.productionBox .hTitle{
    font-size: 24px;
    color: #1C2A39;
    letter-spacing: 0;
    font-weight: 400;
    margin: 10px 0;
}
.productionBox .h3Box{
    padding: 0px 0;
}
.productionBox .h3Box img{
    width: 318px;
    height: 289px;
    margin: 20px 0;
}
.productionBox .h3Box .chileTitle{
    font-size: 18px;
    color: #1C2A39;
    letter-spacing: 0;
    font-weight: 700;
    margin: 20px 0;
}
.productionBox .h3Box .content{
    font-size: 15px;
    color: #4D5865;
    letter-spacing: 1px;
    text-align: justify;
    line-height: 24px;
    font-weight: 400;
}

/* 底部黑色背景列表内容Start */
.footBtn{
    padding: 10px 20px;
    box-sizing: border-box;
    background: #2A2B2C;
}
.footBtn img{
    width: 100%;
    height: 43px;
}
.footBtn p{
    color: #F4F5F6;
    line-height: 25px;
    font-size: 12px;
    margin-top: 10px;
}
.van-cell::after{
    display: none;
}
.van-cell__right-icon{
    color: #fff;
}
.van-cell{
    background: none;
    color: #fff;
}
.navwrap{
    background: #2A2B2C;
    padding-top:10px;
    border-bottom: 1px solid #5C5D5E;
}
/* 底部黑色背景列表内容End */

.contentList{

}
.contentList .coreWrap{
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
}
.contentList .coreWrap li{
    background-color: #fff;
    border:1px solid #EDEEF0;
    width: 50%;
    box-sizing: border-box;
    text-align: center;
    /* height: 276px; */
    line-height: 276px;
    padding: 0;
}
/* .contentList .coreWrap li img{
    width: 188px;
    height: 171px;
} */
.coreWrap{
    background-color: #fff;
}
.coreWrap li{
    padding: 22px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.coreWrap li .comTex{
    flex: 1;
    margin-right: 20px;
}
.coreWrap li .comTex .title{
    color: #1C2A39;
    font-size: 16px;

}
.coreWrap li .comTex .texts{
    color: #4D5865;
    font-size: 12px;
    margin-top: 8px;
    line-height:20px;

}
.coreWrap li .conImg{
    width: 105px;
    height: 80px;
}
.coreWrap li .conImg img{
    width: 100%;
}
.wrap{
    background: #f4f5f6;
}
.vieHead{
    width: 100%;
    height: 50px;
    padding: 0 10px 0 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.wapLogo{
    width: 136px;
    height: 36px;
}
.wapLogo img,.wapmore img{
    width: 100%;
}
.wapmore{
    width: 25px;
    height: 25px;
}
.my-swipe img {

}
.wepTex{
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    /* margin: 35px 0; */
    /* margin-bottom: 10px; */
    background: #fff;
}
.wepTex .title{
    color: #1C2A39;
    font-size: 24px;
    padding: 20px 0;

}
.wepTex .text{
    color: #4D5865;
    font-size: 13px;
    line-height: 22px;

}
.contentBox{
    background: #fff;
    margin-top: 10px;
}
.titleBox{
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #1C2A39;
    font-size: 20px;
    background: url(../../assets/images/wap/title.png) no-repeat left top;
    background-size:29px;
    padding-left: 15px;
    /* border-bottom: 1px solid #EDEEF0; */
}
</style>


// WEBPACK FOOTER //
// src/pages/wapApplication/index.vue